import tw, { css } from 'twin.macro'

// https://github.com/sampotts/plyr/issues/662#issuecomment-498825513
export const plyrWithBrand = css`
  .plyr--full-ui input[type='range'] {
    ${tw`text-inverted-subdued!`}
  }

  .plyr--video .plyr__control.plyr__tab-focus,
  .plyr--video .plyr__control:hover,
  .plyr--video .plyr__control[aria-expanded='true'] {
    ${tw`bg-transparent`}
  }

  .plyr--video .plyr__control--overlaid {
    ${tw`bg-brand-neutral! hover:bg-brand-emphasis! p-6`}
  }

  .plyr__menu__container button {
    ${tw`hover:bg-gray-300!`}
  }

  .plyr__control.plyr__tab-focus {
    /* box-shadow: 0 0 0 5px rgba(YourRGBColor, 0.5); */
  }

  .plyr__menu__container
    .plyr__control[role='menuitemradio'][aria-checked='true']::before {
    ${tw`bg-brand-emphasis`}
  }

  /* workaround for black borders when stretching video */
  /* https://github.com/sampotts/plyr/issues/607#issuecomment-391035531 */
  .plyr__poster {
    ${tw`bg-cover`}
  }

  /* workaround for removing youtube branding and suggested videos */
  /* https://github.com/sampotts/plyr/issues/976#issuecomment-862810641 */
  .plyr iframe[id^='youtube'] {
    top: -50%;
    height: 200%;
  }
`
